import React from "react";
import { SectionTitle } from "../EmployeeForm";
import { Label } from "@radix-ui/react-label";
import { InputText } from "primereact/inputtext";

function Documents({ formData, handleOnChange }) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Documents</SectionTitle>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 w-full">
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Aadhar Number <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.aadharNumber}
            onChange={(e) => handleOnChange("aadharNumber", e.target.value)}
            placeholder="1234 1234 1234"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            PAN Number <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.panNumber}
            onChange={(e) => handleOnChange("panNumber", e.target.value)}
            placeholder="ABCDE1234F"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">PF Number</Label>
          <InputText
            value={formData.pfNumber}
            onChange={(e) => handleOnChange("pfNumber", e.target.value)}
            placeholder="PF Number"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">EPFO UAN Number</Label>
          <InputText
            value={formData.uanNumber}
            onChange={(e) => handleOnChange("uanNumber", e.target.value)}
            placeholder="UAN Number"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">Driving License Number</Label>
          <InputText
            value={formData.drivingLicenseNumber}
            onChange={(e) =>
              handleOnChange("drivingLicenseNumber", e.target.value)
            }
            placeholder="Driving License"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">Passport Number</Label>
          <InputText
            value={formData.passportNumber}
            onChange={(e) => handleOnChange("passportNumber", e.target.value)}
            placeholder="Passport"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
      </div>
    </section>
  );
}

export default Documents;
